angular.module('jv.search.save.service', [])
.service('jvSearchSaveService', [
    '$http', '$q',
    function($http, $q) {
        var baseUrl = jvUrls.jhire + '/action/application/saveSearch';
        this.save = function(name, parameters) {
            return $http.post(baseUrl, {
                name: name,
                searchParameters: parameters
            });
        };
        this.get = function(eid) {
            return $http.get([baseUrl, eid].join('/')).then(function(response) {
                if (response.data && response.data.savedSearch) {
                    return response.data.searchParameters;
                }
                else {
                    return $q.reject();
                }
            });
        };
        this.list = function(page, query, maxResults) {
            page = page || 0;
            return $http.get([baseUrl, 'list'].join('/'), {
                params: {
                    page: page,
                    name: query,
                    maxResults: maxResults,
                    readMode: 0
                }
            }).then(function(response) {
                if (response.data && response.data.savedSearch) {
                    return {
                        results: response.data.savedSearch,
                        total: response.data.count
                    }
                }
                else {
                    return $q.reject();
                }
            });
        };
        this.update = function(eid, name) {
            return $http.put([baseUrl, eid].join('/'), {
                name: name
            });
        };
        this.delete = function(eid) {
            return $http.delete([baseUrl, eid].join('/'));
        };
    }
]);